import React, { useEffect, useState, useMemo } from "react";
import { createPortal } from "react-dom";
import {
  createWorkNature,
  getAllWorkNatures,
  updateWorkNature,
  deleteWorkNature,
} from "../../api/workNature";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ===== Inline style tokens (kept in this file since there's no shared CSS file) =====
const colors = {
  bg: "#ffffff",
  card: "#ffffff",
  border: "#e5e7eb",
  text: "#111827",
  subtext: "#6b7280",
  heading: "#6b7280",
  primary: "#2E5CB8",
  primaryHover: "#244a94",
  danger: "#e53e3e",
  dangerBg: "#fdecec",
  editBg: "#f3f4f6",
  editIcon: "#374151",
  inputBorder: "#d1d5db",
};

const styles = {
  page: {
    background: colors.bg,
    height: "calc(100vh - 62px)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxSizing: "border-box",
    padding: "32px 40px",
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "24px",
  },
  title: {
    fontSize: "24px",
    fontWeight: 700,
    color: colors.text,
    margin: 0,
  },
  subtitle: {
    fontSize: "14px",
    color: colors.subtext,
    marginTop: "4px",
  },
  addBtn: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: colors.primary,
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 18px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  },
  searchWrap: {
    position: "relative",
    marginBottom: "20px",
    maxWidth: "420px",
  },
  searchInput: {
    width: "100%",
    padding: "10px 14px 10px 38px",
    borderRadius: "8px",
    border: `1px solid ${colors.inputBorder}`,
    fontSize: "14px",
    color: colors.text,
    outline: "none",
    background: "#fff",
    boxSizing: "border-box",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: colors.subtext,
  },
  card: {
    background: colors.card,
    borderRadius: "12px",
    border: `1px solid ${colors.border}`,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    fontSize: "12px",
    fontWeight: 600,
    color: "#ffffff",
    textTransform: "none",
    padding: "14px 24px",
    borderBottom: `1px solid ${colors.border}`,
    background: colors.primary,
    borderRight: "1px solid rgba(255,255,255,0.2)",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
 td: {
    padding: "18px 24px",
    fontSize: "14px",
    color: colors.text,
    borderBottom: `1px solid ${colors.border}`,
    borderRight: `1px solid ${colors.border}`,
  },
  tdBold: {
    fontWeight: 600,
    color: colors.text,
  },
 actionsCell: {
    padding: "18px 24px",
    borderBottom: `1px solid ${colors.border}`,
    textAlign: "center",
    borderRight: `1px solid ${colors.border}`,
  },
 iconBtn: {
  width: "28px",
  height: "28px",
  borderRadius: "6px",
  border: "none",
  background: "transparent",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  marginRight: "10px",
},

  emptyRow: {
    padding: "40px",
    textAlign: "center",
    color: colors.subtext,
    fontSize: "14px",
  },
  // Modal
 overlay: {
  position: "fixed",
  inset: 0,
  background: "rgba(17,24,39,0.5)",
  display: "flex",
  justifyContent: "flex-end",
 zIndex: 9999,
},

modal: {
  background: colors.card,
  width: "420px",
  maxWidth: "90vw",
  height: "100%",
  padding: "28px",
  boxShadow: "-4px 0 24px rgba(0,0,0,0.08)",
  overflowY: "auto",
  boxSizing: "border-box",
},

  modalHeader: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "16px",
  marginBottom: "20px",
  borderBottom: `1px solid ${colors.border}`,
},
modalTitle: {
  fontSize: "18px",
  fontWeight: 700,
  color: colors.text,
  margin: 0,
},
closeBtn: {
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontSize: "18px",
  color: colors.subtext,
  lineHeight: 1,
  padding: "4px",
},

  label: {
    fontSize: "13px",
    fontWeight: 600,
    color: colors.text,
    marginBottom: "6px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "8px",
    border: `1px solid ${colors.inputBorder}`,
    fontSize: "14px",
    boxSizing: "border-box",
    outline: "none",
  },
  errorText: {
    color: colors.danger,
    fontSize: "12.5px",
    marginTop: "6px",
  },
  modalActions: {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  marginTop: "24px",
},
  cancelBtn: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: `1px solid ${colors.inputBorder}`,
    background: "#fff",
    color: colors.text,
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
  submitBtn: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "none",
    background: colors.primary,
    color: "#fff",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
 statusPill: {
  display: "inline-block",
  padding: "3px 12px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 500,
  background: "#f0fdf4",
  color: "#15803d",
  border: "1px solid #bbf7d0",
},
statusPillInactive: {
  background: "#f9fafb",
  color: "#6b7280",
  border: "1px solid #e5e7eb",
},
confirmOverlay: {
  position: "fixed",
  inset: 0,
  background: "rgba(17,24,39,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
},
confirmBox: {
  background: colors.card,
  width: "380px",
  maxWidth: "90vw",
  borderRadius: "12px",
  padding: "24px",
  boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
  boxSizing: "border-box",
},
confirmTitle: {
  fontSize: "16px",
  fontWeight: 700,
  color: colors.text,
  margin: "0 0 8px 0",
},
confirmText: {
  fontSize: "14px",
  color: colors.subtext,
  margin: 0,
},
confirmActions: {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  marginTop: "22px",
},
paginationBar: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 24px",
},
paginationInfo: {
  fontSize: "13px",
  color: colors.subtext,
},
paginationControls: {
  display: "flex",
  alignItems: "center",
  gap: "6px",
},
pageBtn: {
  minWidth: "32px",
  height: "32px",
  padding: "0 8px",
  borderRadius: "6px",
  border: `1px solid ${colors.inputBorder}`,
  background: "#fff",
  color: colors.text,
  fontSize: "13px",
  fontWeight: 600,
  cursor: "pointer",
},
pageBtnActive: {
  background: colors.primary,
  color: "#fff",
  border: `1px solid ${colors.primary}`,
},
pageBtnDisabled: {
  opacity: 0.4,
  cursor: "not-allowed",
},
};


// ===== Small inline icon components (no extra icon library needed) =====
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={colors.editIcon} strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={colors.danger} strokeWidth="2">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const WorkNature = () => {
  const [workNatureName, setWorkNatureName] = useState("");
  const [description, setDescription] = useState("");
const [status, setStatus] = useState("Active");
  const [workNatures, setWorkNatures] = useState([]);
  const [editId, setEditId] = useState(null);
 const [workNatureError, setWorkNatureError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 10;
  const token = localStorage.getItem("token");

  // FETCH ALL
  const fetchWorkNatures = async () => {
    try {
      const response = await getAllWorkNatures(token);
      setWorkNatures(response.data);
    } catch (error) {
      console.error("Error fetching work natures", error);
    }
  };

  useEffect(() => {
    fetchWorkNatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleWorkNatureChange = (e) => {
    const value = e.target.value;
    setWorkNatureName(value);

    const trimmedValue = value.trim();

    if (value === "") {
      setWorkNatureError("");
      return;
    }
    if (trimmedValue === "") {
      setWorkNatureError("Work Nature Name cannot be spaces only");
      return;
    }
  if (!/[a-zA-Z]/.test(trimmedValue)) {
      setWorkNatureError("Work Nature Name cannot contain only numbers and special characters");
      return;
    }
    setWorkNatureError("");
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setDescription(value);

    const trimmedValue = value.trim();

    if (trimmedValue === "") {
      setDescriptionError("");
      return;
    }
    if (!/[a-zA-Z]/.test(trimmedValue)) {
      setDescriptionError("Description cannot contain only numbers and special characters");
      return;
    }
    setDescriptionError("");
  };

  // SUBMIT (CREATE / UPDATE)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setWorkNatureError("");
    let hasError = false;

    const trimmedValue = workNatureName.trim();

    if (!workNatureName || trimmedValue === "") {
      setWorkNatureError("Work Nature Name is required");
      hasError = true;
   } else if (!/[a-zA-Z]/.test(trimmedValue)) {
      setWorkNatureError("Work Nature Name cannot contain only numbers and special characters");
      hasError = true;
    }

    const trimmedDescription = description.trim();

    if (trimmedDescription !== "" && !/[a-zA-Z]/.test(trimmedDescription)) {
      setDescriptionError("Description cannot contain only numbers and special characters");
      hasError = true;
    }

    if (hasError) return;

   const payload = { workNatureName, description, status };

    try {
      if (editId) {
        await updateWorkNature(editId, payload, token);
        toast.success("Work Nature updated successfully");
      } else {
        await createWorkNature(payload, token);
        toast.success("Work Nature created successfully");
      }
      handleCancel();
      fetchWorkNatures();
    } catch (error) {
      toast.error("Something went wrong. Please try again");
    }
  };

  // EDIT
 const handleEdit = (workNature) => {
  setWorkNatureName(workNature.workNatureName);
  setDescription(workNature.description || "");
  setStatus(workNature.status || "Active");
  setEditId(workNature.id);
  setWorkNatureError("");
  setDescriptionError("");
  setShowModal(true);
};

  // ADD (open empty modal)
  const handleOpenAdd = () => {
  setWorkNatureName("");
  setDescription("");
  setStatus("Active");
  setEditId(null);
  setWorkNatureError("");
  setDescriptionError("");
  setShowModal(true);
};
  // CANCEL
const handleCancel = () => {
  setWorkNatureName("");
  setDescription("");
  setStatus("Active");
  setEditId(null);
  setWorkNatureError("");
  setDescriptionError("");
  setShowModal(false);
};
// DELETE - opens the custom confirm modal instead of window.confirm
  const handleDelete = (id) => {
    setDeleteTargetId(id);
  };

  const confirmDelete = async () => {
    const id = deleteTargetId;
    setDeleteTargetId(null);
    try {
      await deleteWorkNature(id, token);
      toast.success("Work Nature deleted successfully");
      fetchWorkNatures();
    } catch (error) {
      toast.error(" This Work Nature is currently in use and cannot be deleted.");
    }
  };

  const cancelDelete = () => setDeleteTargetId(null);

  const filteredWorkNatures = useMemo(() => {
    if (!searchTerm.trim()) return workNatures;
    return workNatures.filter((w) =>
      w.workNatureName.toLowerCase().includes(searchTerm.trim().toLowerCase())
    );
  }, [workNatures, searchTerm]);

  const totalPages = Math.max(1, Math.ceil(filteredWorkNatures.length / PAGE_SIZE));

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, workNatures]);

  const paginatedWorkNatures = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return filteredWorkNatures.slice(start, start + PAGE_SIZE);
  }, [filteredWorkNatures, currentPage]);

  const goToPage = (page) => {
    setCurrentPage(Math.min(Math.max(page, 1), totalPages));
  };

  return (
    <>
      <ToastContainer />
      <div style={styles.page}>
        <div style={styles.headerRow}>
          <div>
            <h1 className="page-main-heading">Work Nature Master</h1>
<div className="page-sub-heading">Manage work categories available in Daily Reporting.</div>
          </div>
          <button
            style={styles.addBtn}
            onClick={handleOpenAdd}
            onMouseOver={(e) => (e.currentTarget.style.background = colors.primaryHover)}
            onMouseOut={(e) => (e.currentTarget.style.background = colors.primary)}
          >
            <PlusIcon />
            Add Work Nature
          </button>
        </div>

        <div style={styles.searchWrap}>
          <span style={styles.searchIcon}>
            <SearchIcon />
          </span>
          <input
            type="text"
            placeholder="Search work natures..."
            style={styles.searchInput}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div style={styles.card}>
          <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
          <table style={styles.table}>
            <thead>
              <tr>
               <th style={styles.th}>Work Nature</th>
<th style={styles.th}>Description</th>
<th style={styles.th}>Status</th>
<th style={styles.th}>Last Updated</th>
<th style={{ ...styles.th, textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedWorkNatures.length === 0 ? (
                <tr>
                  <td colSpan={5} style={styles.emptyRow}>
                    No data found
                  </td>
                </tr>
              ) : (
                paginatedWorkNatures.map((workNature) => (
                  <tr key={workNature.id}>
                    <td style={{ ...styles.td, ...styles.tdBold }}>
  {workNature.workNatureName}
</td>
<td style={styles.td}>{workNature.description || "-"}</td>
<td style={styles.td}>
  <span
    style={{
      ...styles.statusPill,
      ...(workNature.status !== "Active" ? styles.statusPillInactive : {}),
    }}
  >
    {workNature.status || "Active"}
  </span>
</td>
<td style={styles.td}>{formatDate(workNature.lastUpdated)}</td>
<td style={styles.actionsCell}>
                      <button
  style={styles.iconBtn}
  onClick={() => handleEdit(workNature)}
  title="Edit"
>
  <EditIcon />
</button>
<button
  style={styles.iconBtn}
  onClick={() => handleDelete(workNature.id)}
  title="Delete"
>
  <TrashIcon />
</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          </div>
          {filteredWorkNatures.length > 0 && (
            <div style={styles.paginationBar}>
              <span style={styles.paginationInfo}>
                Showing {(currentPage - 1) * PAGE_SIZE + 1}
                {"–"}
                {Math.min(currentPage * PAGE_SIZE, filteredWorkNatures.length)} of{" "}
                {filteredWorkNatures.length}
              </span>
              <div style={styles.paginationControls}>
                <button
                  type="button"
                  style={{
                    ...styles.pageBtn,
                    ...(currentPage === 1 ? styles.pageBtnDisabled : {}),
                  }}
                  disabled={currentPage === 1}
                  onClick={() => goToPage(currentPage - 1)}
                >
                  Prev
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    type="button"
                    style={{
                      ...styles.pageBtn,
                      ...(page === currentPage ? styles.pageBtnActive : {}),
                    }}
                    onClick={() => goToPage(page)}
                  >
                    {page}
                  </button>
                ))}
                <button
                  type="button"
                  style={{
                    ...styles.pageBtn,
                    ...(currentPage === totalPages ? styles.pageBtnDisabled : {}),
                  }}
                  disabled={currentPage === totalPages}
                  onClick={() => goToPage(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

     {showModal && (
        <div style={styles.overlay} onClick={handleCancel}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
  <h2 style={styles.modalTitle}>
    {editId ? "Edit Work Nature" : "Add Work Nature"}
  </h2>
  <button style={styles.closeBtn} onClick={handleCancel} title="Close">
    ✕
  </button>
</div>
            <form onSubmit={handleSubmit}>
              <label style={styles.label}>
  Work Nature Name<span style={{ color: colors.danger }}>*</span>
</label>
<input
  type="text"
  style={styles.input}
  placeholder="e.g. Development"
  value={workNatureName}
  onChange={handleWorkNatureChange}
  autoFocus
/>
{workNatureError && <div style={styles.errorText}>{workNatureError}</div>}

<label style={{ ...styles.label, marginTop: "18px" }}>Description</label>
<textarea
  style={{ ...styles.input, resize: "vertical", minHeight: "80px" }}
  placeholder="What kind of work falls under this category..."
  value={description}
  onChange={handleDescriptionChange}
/>
{descriptionError && <div style={styles.errorText}>{descriptionError}</div>}

<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "18px",
  }}
>
  <label style={{ ...styles.label, marginBottom: 0 }}>
    Status
    <span
      style={{
        marginLeft: 8,
        fontWeight: 500,
        fontSize: 12,
        color: status === "Active" ? "#15803d" : colors.subtext,
      }}
    >
      {status}
    </span>
  </label>

  <div
    role="switch"
    aria-checked={status === "Active"}
    title={status === "Active" ? "Active (click to make Inactive)" : "Inactive (click to make Active)"}
    onClick={() => setStatus(status === "Active" ? "Inactive" : "Active")}
    style={{
      width: 34,
      height: 18,
      borderRadius: 50,
      background: status === "Active" ? "#22c55e" : "#ccc",
      cursor: "pointer",
      position: "relative",
      transition: "background 0.2s",
      flexShrink: 0,
    }}
  >
    <div
      style={{
        position: "absolute",
        top: 2,
        left: status === "Active" ? 18 : 2,
        width: 14,
        height: 14,
        borderRadius: "50%",
        background: "#fff",
        transition: "left 0.2s",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
      }}
    />
  </div>
</div>

              <div style={styles.modalActions}>
                <button type="button" style={styles.cancelBtn} onClick={handleCancel}>
                  Cancel
                </button>
                <button type="submit" style={styles.submitBtn}>
  {editId ? "Update" : "Save"}
</button>
              </div>
            </form>
          </div>
        </div>
     )}

      {deleteTargetId !== null &&
        createPortal(
          <div style={styles.confirmOverlay} onClick={cancelDelete}>
            <div style={styles.confirmBox} onClick={(e) => e.stopPropagation()}>
              <h3 style={styles.confirmTitle}>Delete Work Nature</h3>
              <p style={styles.confirmText}>
                Are you sure you want to delete this work nature?
              </p>
              <div style={styles.confirmActions}>
                <button type="button" style={styles.cancelBtn} onClick={cancelDelete}>
                  Cancel
                </button>
                <button
                  type="button"
                  style={{ ...styles.submitBtn, background: colors.danger }}
                  onClick={confirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default WorkNature;
